/* eslint-disable no-nested-ternary */
import React from "react";

import { format, intervalToDuration } from "date-fns";
import { useTranslation } from "react-i18next";
import { BsBookmark, BsCalendar4, BsClock } from "react-icons/bs";
import { FiUser } from "react-icons/fi";

import Timeline from "../../../../../../../components/Generic/TimeLine";
import { Bookmark } from "../../../../../../../models/bookmark";
import { getAmPmHour } from "../../../../../../../util/Format";
import { getUserFullname } from "../../../../../../../util/names";
import useStyles from "./styles";

const MILI_SECONDS = 1000; // miliseconds

interface Props {
  bookmarks: Bookmark[];
  isFetching: boolean;
}

const BookmarkTimeline = ({ isFetching, bookmarks }: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const setVideoDuration = (time?: number): string => {
    if (time) {
      const duration = intervalToDuration({
        start: 0,
        end: time * MILI_SECONDS,
      });

      return `${translate("time")} ${duration.minutes?.toString().padStart(2, "0") || "00"}:${
        duration.seconds?.toString().padStart(2, "0") || "00"
      }`;
    }

    return "00:00";
  };

  const renderSubtitle = (item: Bookmark): React.ReactNode => {
    if (item) {
      return (
        <div className={classes.timelineSubtitle}>
          <div className={classes.timelineSubtitle}>
            <BsCalendar4 size={14} />
            <span>{format(new Date(item.markDate), "dd/MM/yyyy")}</span>
          </div>
          <div className={classes.timelineSubtitle}>
            <BsClock size={14} />
            <span>{getAmPmHour(format(new Date(item.markDate), "HH:mm"))}</span>
          </div>
          <div className={classes.timelineSubtitle}>
            <FiUser size={14} />
            <span>{getUserFullname(item.user)}</span>
          </div>
        </div>
      );
    }

    return <></>;
  };

  return (
    <div>
      <p className={classes.bookmarkTitle}>{translate("bookmarks")}</p>
      {isFetching ? (
        <div className={`${classes.uploadProgress} withAnimation`}>
          <BsBookmark size={24} />
          <span>{translate("fetchingBookmarks")}</span>
        </div>
      ) : bookmarks.length > 0 ? (
        <Timeline
          items={bookmarks}
          icon={<BsBookmark size={14} color="#308CDB" />}
          renderTitle={(item: Bookmark) => (
            <span className={classes.bookmarkTitle}>{setVideoDuration(item.videoTime)}</span>
          )}
          renderSubtitle={(item: Bookmark) => renderSubtitle(item)}
        />
      ) : (
        <div className={classes.uploadProgress}>
          <BsBookmark size={24} />
          <span>{translate("noBookmarksAvailable")}</span>
        </div>
      )}
    </div>
  );
};

export default BookmarkTimeline;
